import { cx } from '@emotion/css';
import { Anchor } from '@snapchat/snap-design-system-marketing';
import type { FC, ReactNode } from 'react';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { hiddenCss, successTextCss } from './ArDownloadFormBlock.styles';

interface ArDownloadSuccessProps {
  successText: ReactNode;
  downloadUrl: string | undefined;
}

export const ArDownloadSuccess: FC<ArDownloadSuccessProps> = ({ successText, downloadUrl }) => {
  const anchorTag = useRef<HTMLAnchorElement>(null);
  const { pathname } = useLocation();

  const forSpecificVersion = pathname === '/older-versions' || /^\/download\/v[^/]+/.test(pathname);

  useEffect(() => {
    if (downloadUrl && anchorTag.current) {
      anchorTag.current.click();
    }
  }, [downloadUrl]);

  return (
    <div className={cx({ [successTextCss]: !forSpecificVersion })}>
      {successText}
      <Anchor
        data-testid="test-anchor-download"
        ref={anchorTag}
        href={downloadUrl}
        download
        className={hiddenCss}
      >
        Hidden download link
      </Anchor>
    </div>
  );
};
